/* Upsell de billeteras + llavero: carrusel rotativo (carrito) y fila fija (producto).
   El agregar usa ShopifyAPI.addItemFromForm (misma API que el boton nativo del
   tema), asi dispara la notificacion "agregado al carrito" igual que siempre.

   Usa delegacion de eventos (listeners en document) en vez de atar un listener
   a cada tarjeta: el carrusel Slick clona/reconstruye tarjetas internamente, y
   un listener atado directo a un nodo se pierde si ese nodo es reemplazado.
   La delegacion sigue funcionando sin importar que nodos cree o reemplace Slick. */
(function () {
  function initCarousel() {
    if (typeof jQuery === "undefined" || !jQuery.fn.slick) return;
    var $track = jQuery(".js-bita-upsell-carousel");
    if (!$track.length || $track.hasClass("slick-initialized")) return;
    $track.slick({
      slidesToShow: 2,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 4000,
      infinite: true,
      arrows: true,
      dots: false,
      pauseOnHover: true,
      pauseOnFocus: true,
      prevArrow: '<button class="slick-prev" aria-label="Anterior" type="button">Anterior</button>',
      nextArrow: '<button class="slick-next" aria-label="Siguiente" type="button">Siguiente</button>',
      responsive: [
        { breakpoint: 480, settings: { slidesToShow: 1 } }
      ]
    });
  }

  document.addEventListener("click", function (evt) {
    var chip = evt.target.closest(".bita-upsell__color-chip");
    if (!chip) return;
    var item = chip.closest(".bita-upsell__item");
    if (!item) return;

    item.querySelectorAll(".bita-upsell__color-chip").forEach(function (c) {
      c.classList.remove("is-selected");
      c.setAttribute("aria-pressed", "false");
    });
    chip.classList.add("is-selected");
    chip.setAttribute("aria-pressed", "true");

    var variantInput = item.querySelector(".js-bita-upsell-variant-id");
    var priceEl = item.querySelector(".js-bita-upsell-price");
    var imgEl = item.querySelector(".js-bita-upsell-img");
    if (variantInput) variantInput.value = chip.getAttribute("data-variant-id");
    if (priceEl) priceEl.textContent = chip.getAttribute("data-price");
    if (imgEl) imgEl.src = chip.getAttribute("data-img");
  });

  document.addEventListener("submit", function (evt) {
    var form = evt.target.closest ? evt.target.closest(".js-bita-upsell-form") : null;
    if (!form) return;
    evt.preventDefault();

    var btn = form.querySelector(".js-bita-upsell-btn");
    var btnText = form.querySelector(".js-bita-upsell-btn-text");
    var wrapper = form.closest(".bita-upsell");
    var isCarouselMode = wrapper && wrapper.classList.contains("bita-upsell--carousel");

    if (!btn || btn.disabled || typeof ShopifyAPI === "undefined" || !ShopifyAPI.addItemFromForm) return;
    btn.disabled = true;

    // red de seguridad: si por lo que sea nunca llega ni exito ni error
    // (ej. una respuesta que se pierde), no dejar el boton colgado para siempre
    var safetyTimer = setTimeout(function () {
      if (btn.disabled) {
        btn.disabled = false;
        if (btnText) btnText.textContent = "+ Agregar";
      }
    }, 6000);

    ShopifyAPI.addItemFromForm(
      form,
      function () {
        clearTimeout(safetyTimer);
        // exito: dispara beforeAddItem/afterAddItem.ajaxCart internamente,
        // lo que abre la notificacion nativa. ajaxCart.load() refresca
        // #CartCount y el preview del carrito (mismo mecanismo que usa
        // el boton nativo "Agregar al carrito").
        if (typeof ajaxCart !== "undefined" && ajaxCart.load) ajaxCart.load();

        if (btnText) btnText.textContent = "¡Agregado!";
        btn.classList.add("is-added");

        if (isCarouselMode) {
          // en el carrito: recargar despues de que se vea la notificacion,
          // para que la lista de items y el subtotal queden al dia
          setTimeout(function () {
            window.location.reload();
          }, 1400);
        } else {
          setTimeout(function () {
            btn.disabled = false;
            if (btnText) btnText.textContent = "+ Agregar";
            btn.classList.remove("is-added");
          }, 2000);
        }
      },
      function () {
        clearTimeout(safetyTimer);
        if (btnText) btnText.textContent = "Error, intenta de nuevo";
        btn.disabled = false;
      }
    );
  });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initCarousel);
  } else {
    initCarousel();
  }
})();
